module.exports = __webpack_public_path__ + "img/refresh-right.8a206597.svg";